import { Box, Button, Container, CssBaseline, Divider, Grid, IconButton, Stack, TextField, ThemeProvider, Typography, createTheme } from "@mui/material";
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { useEffect, useState } from "react";
import { getAllFromEduconCursosRegistrados } from "../../../../database/dbEduconCursosRegistrados";
import { WaitDialog } from "../../../modules/dialogs/WaitDialog";
import { getAllEventosConRegistro } from "../../../../database/dbEventosConRegistro";
import { getByRegistroClaveProyecto } from "../../../../database/dbRegistroGeneral";
import MUIDataTable from "mui-datatables";

const textLabels = {
    body: {
        noMatch: "Ingresar datos",
        toolTip: "Ordenar",
        columnHeaderTooltip: column => `Ordenar por ${column.label}`
    },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Renglones por página:",
        displayRows: "de",
    },
    toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Mostrar Columnas",
        filterTable: "Filtrar tabla",
    },
    filter: {
        all: "Todo",
        title: "FILTROS",
        reset: "RESETEAR",
    },
    viewColumns: {
      title: "Mostrar Columnas",
    //   titleAria: "Show/Hide Table Columns",
    },
};
const reportOptions = {
    print: false,
    search: false,
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    fixedHeader: true,
    fixedSelectColumn: false,
    tableBodyHeight: "360px",
    selectableRows: "none",
    rowsPerPage: 30,
    rowsPerPageOptions: [30, 60, 100],

    //* Necesario para que soporte caracteres especiales (special characters) en la descarga
    onDownload: (buildHead, buildBody, columns, data) => {
        return "\uFEFF" + buildHead(columns) + buildBody(data); 
    },
    
    textLabels: textLabels,
};


const columnOptions = {
    customBodyRender: val => <div style={{ width: "140px" }}>{ val }</div>
};
const reportColumns = [
    { name: "registroReferencia",
        label: "Referencia",
        options: {
            filter: true,
            sort: true,
            setCellProps: () => ({
                style: {
                    whiteSpace: "nowrap",
                    position: "sticky",
                    left: "0",
                    background: "whitesmoke",
                    fontWeight: 600,
                    zIndex: 100,
                },
            }),
            setCellHeaderProps: () => ({
                style: {
                    whiteSpace: "nowrap",
                    position: "sticky",
                    left: 0,
                    background: "white",
                    fontWeight: 600,
                    textAlign: "center",
                    zIndex: 101,
                },
            }),
        },
    },
    { name: "compPagoURL", label: "Comprobante de pago", 
        options: {
            filter: true,
            sort: false,
            customBodyRender: val => {
                return (
                <div>
                    { val 
                    ?
                        <IconButton href={ val } color='info' target='_blank'>
                            <OpenInNewOutlinedIcon />
                        </IconButton>
                    : 'Pendiente | No aplica'
                    }
                </div>
                );
            }
        },
 },
    { name: "partNombres", label: "Nombres", options: columnOptions, },
    { name: "partApellidoPaterno", label: "Apellido Paterno", options: columnOptions, },
    { name: "partApellidoMaterno", label: "Apellido Materno", options: columnOptions, },
    { name: "partInstProcedencia", label: "Institución de Procedencia", options: columnOptions, },
    { name: "tipoRegistro", label: "Tipo de Registro", options: columnOptions, },
    { name: "partEdad", label: "Edad", },
    { name: "partGradoAcademico", label: "Grado Académico", options: columnOptions, },
    { name: "partSexo", label: "Sexo", },
    { name: "partNacionalidad", label: "Nacionalidad", },
    { name: "partTelefono", label: "Teléfono", },
    { name: "partEmail", label: "Email", },
    { name: "partLenguaIndigena", label: "Lengua Indígena", options: columnOptions, },
    { name: "partDiscapacidad", label: "Discapacidad", options: columnOptions, },
    ];


const ACT_INITIAL_STATE = {
    nombre: 'Initial title',
    fechaInicio: '12/12/2112',
}


//! En la tabla EventosConRegistro, el campo "solicitudFolio" se va a utilizar como:
// - el id de la solicitud de la actividad EDUCON o 
// - como el numero de solicitud de eventos.


const EduconSolicitud = () => {

    const [isWaiting, setIsWaiting] = useState(true);
    const [registrados, setRegistrados] = useState([]);
    const [solNumber, setSolNumber] = useState(0);

    const [activity, setActivity] = useState(ACT_INITIAL_STATE);
    const [reportData, setReportData] = useState([]);

    //* Al presionar el boton "CONSULTAR"
    const handleSubmit = async(e) => {
        e.preventDefault();
        // Obtenemos la actividad por su numero de solicitud
        const actividad = registrados.find(r => r.solicitudID.toString() === solNumber);
        console.log(actividad);

        // No existe, salte
        if (!actividad) {
            console.log(`SolicitudID ${ solNumber } no existe en EduconCursosRegistrados`);
            resetValues();
            return;
        }

        setActivity(actividad);

        const { cve_Proyec, fechaInicio, solicitudID } = actividad;
        console.log({ cve_Proyec, fechaInicio, solicitudID });

        // TODO: Obtener el EventoConRegistro a partir de la solicitudFolio
        const allECR = await getAllEventosConRegistro();
        const eventosConRegistro = allECR.data ? allECR.data : [];
        // console.log({eventosConRegistro});
        
        // Recuperalo desde EventosConRegistro por medio de la clave del proyecto
        const ecr = eventosConRegistro.find( e => e.solicitudFolio === solicitudID.toString());
        if (!ecr) {
            console.log(`SolicitudID ${ solicitudID } no existe en EventosConRegistro`);
            resetValues();
            return;
        }

        const { data: records } = await getByRegistroClaveProyecto(ecr.claveProyecto);
        console.log({ records })

        const dataToShow = [];
        records.forEach(r => {

            console.log({r});
            const iAd = JSON.parse(r.infoAdicional);
            console.log({iAd});
            dataToShow.push({
                registroReferencia: r.registroReferencia,
                partNombres: r.partNombres,
                partApellidoPaterno: r.partApellidoPaterno,
                partApellidoMaterno: r.partApellidoMaterno,
                partInstProcedencia: iAd.partInstProcedencia,
                tipoRegistro: r.tipoRegistro,
                partEdad: iAd.partEdad,
                partGradoAcademico: iAd.partGradoAcademico,
                partSexo: iAd.partSexo,
                partNacionalidad: r.partPais,
                partTelefono: iAd.partTelefono,
                partEmail: r.partCorreo,
                partLenguaIndigena: iAd.partLenguaIndigena,
                partDiscapacidad: iAd.partDiscapacidad,

                compPagoURL: iAd.compPagoURL,
            })
        })

        setReportData(dataToShow);
        console.log({dataToShow});
    }

    const resetValues = () => {

        setActivity(ACT_INITIAL_STATE);
        setReportData([]);
    }
/**

- De la UI a CursosRegistrados es por el numero de solicitud de actividad
- Obtenemos 1 elemento
//* Si el numero de proyecto es 0, es una actividad que no cobra
//! ¿Como lo resolvemos aqui?

//* Si el numero de proyecto es !== 0
- De CursosRegistrados a EventosConRegistro la consulta se hace por el numero de proyecto
- Obtenemos 0 o mas elementos
- Filtramos por la fecha de inicio de la actividad
- Obtenemos 1 elemento
- 

 */

    useEffect(() => {
      const getInitialValues = async() => {
        const { data } = await getAllFromEduconCursosRegistrados();
        setRegistrados(data);
        setIsWaiting(false);
      }
      getInitialValues();
    }, [ ]);
    

    return (
        <>
        <ThemeProvider theme={createTheme()}>
            <Container component="main">
                <CssBaseline />

                <WaitDialog show={ isWaiting } />

                <Grid container spacing={1} sx={{ p: 2 }}  maxWidth="xl" >
                    <Box display="flex" flexDirection="row" flex={ 1 }>
                        <Grid item xs={12}>
                            <Typography variant="h4">Consulta EDUCON</Typography>
                            <Typography variant="title1">Reporte general</Typography>
                        </Grid>
                    </Box>
                </Grid>
                <Box
                    autoComplete="off"
                    component="form"
                    display="flex"
                    flex={ 1 }
                    flexDirection="row"
                    onSubmit={ handleSubmit }
                    noValidate
                    sx={{ mt: 2 }}
                >
                    <TextField 
                        type="number"
                        inputProps={{ style: { textAlign: 'right' }}}
                        label="No. de solicitud"
                        id="solicitud"
                        name="solicitud"
                        size="small"
                        value={ solNumber }
                        onChange={ ({ target }) => setSolNumber(target.value) }
                    />
                    <Box sx={{ mx: 1, my: "auto" }}>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                        >
                            Consultar
                        </Button>
                    </Box>
                </Box>
                <Divider light sx={{ marginY: 2 }} />

                {/* Aqui el contenido que se va a actualizar de acuerdo a la actividad indicada */}
                <Box
                    display={ reportData.length > 0 ? 'flex' : 'none'}
                    flexDirection="column"
                >
                    <Grid container spacing={ 1 }>
                        <Grid item xs={ 2 }>
                            <TextField label='Fecha de inicio'
                                value={ activity.fechaInicio.slice(0, 10) }
                                variant='standard'
                            />    
                        </Grid>
                        <Grid item xs={ 10 }>
                            <TextField label='Actividad'
                                fullWidth
                                value={ activity.nombre }
                                variant='standard'
                            />
                        </Grid>
                    </Grid>
                    <Stack direction="column" marginTop={ 1 } marginBottom={ 6 }>
                        <MUIDataTable
                            title={ "Registros de participantes" }
                            data={ reportData }
                            columns={ reportColumns }
                            options={ reportOptions }
                        />
                    </Stack>

                </Box>
            </Container>
        </ThemeProvider>
        </>
    )
}

export default EduconSolicitud;